import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as layoutService from "../view/layoutService";
import { withMainLayout } from "../view/LayoutHOCs"
import { InfoBoxes } from "../info-boxes/InfoBoxes";
import { useHistory } from "react-router-dom";
import RecentViolationsTableSection from "./RecentViolationsTableSection";



const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "RecentViolations",
        redirectTo: "/recentviolations",
    }
]


function RecentViolationsPage() {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('Recent Violations')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <>
            <InfoBoxes />
            <RecentViolationsTableSection />
        </>
    )

}

export default withMainLayout(connect()(RecentViolationsPage));